import { useState, useEffect } from 'react';

const DEFAULT_GEOCHECK_URL = 'https://api.svt.se/geocheck';

export const useUserIsAbroad = (url = DEFAULT_GEOCHECK_URL): boolean => {
    const [userIsAbroad, setUserIsAbroad] = useState(false);

    useEffect(() => {
        (async () => {
            let response: Response;
            try {
                response = await fetch(url);
            } catch {
                //
            }

            if (response?.status === 403) {
                setUserIsAbroad(true);
            }
        })();
    }, [setUserIsAbroad, url]);

    return userIsAbroad;
};
